import { useTheme } from '../contexts/ThemeContext'
import 'primeicons/primeicons.css'

export default function OtherServicesSection() {
  const { theme } = useTheme()

  const handleZaloContact = (phone: string) => {
    // Mở Zalo chat với số điện thoại
    window.open(`https://zalo.me/${phone}`, '_blank')
  }

  return (
    <section className={`py-12 md:py-16 px-4 ${theme === 'dark' ? 'bg-black' : 'bg-gray-200'}`}>
      <div className="container mx-auto">
        {/* Header */}
        <div className="text-center mb-10">
          <h2 className={`text-3xl md:text-4xl font-bold mb-4 ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>
            Các dịch vụ khác
          </h2>
          <p className={`text-base md:text-lg ${theme === 'dark' ? 'text-gray-300' : 'text-gray-700'}`}>
            Chương trình huấn luyện linh hoạt theo nhu cầu của bạn
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-6 md:gap-8">
            {/* Card 1: Huấn Luyện Doanh Nghiệp */}
            <div className={`rounded-xl border ${theme === 'dark' ? 'border-gold-500/40 bg-black/60' : 'border-gold-400 bg-white'} p-6 md:p-8 shadow-lg ${theme === 'dark' ? 'shadow-gold-500/20' : 'shadow-gray-200'} hover:shadow-xl transition-all duration-300`}>
              <div className="flex flex-col h-full">
                {/* Title */}
                <h3 className={`text-xl md:text-2xl font-bold mb-4 ${theme === 'dark' ? 'text-gold-400' : 'text-gold-500'}`}>
                  Huấn Luyện Doanh Nghiệp
                </h3>

                {/* Description */}
                <p className={`text-sm md:text-base leading-relaxed mb-6 flex-grow ${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'}`}>
                  Chương trình huấn luyện cho công ty, trường học, đội nhóm
                </p>

                {/* CTA Button */}
                <button
                  onClick={() => handleZaloContact('0703577789')}
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gold-gradient text-white font-bold rounded-lg hover:shadow-lg hover:shadow-gold-500/50 transition transform hover:scale-105"
                >
                  <i className="pi pi-phone"></i>
                  <span>Liên hệ tư vấn – <strong>Coach Nhật</strong></span>
                </button>
              </div>
            </div>

            {/* Card 2: Học 1 kèm 1 */}
            <div className={`rounded-xl border ${theme === 'dark' ? 'border-gold-500/40 bg-black/60' : 'border-gold-400 bg-white'} p-6 md:p-8 shadow-lg ${theme === 'dark' ? 'shadow-gold-500/20' : 'shadow-gray-200'} hover:shadow-xl transition-all duration-300`}>
              <div className="flex flex-col h-full">
                {/* Title */}
                <h3 className={`text-xl md:text-2xl font-bold mb-4 ${theme === 'dark' ? 'text-gold-400' : 'text-gold-500'}`}>
                  Học 1 kèm 1
                </h3>

                {/* Description */}
                <p className={`text-sm md:text-base leading-relaxed mb-6 flex-grow ${theme === 'dark' ? 'text-gray-300' : 'text-gray-600'}`}>
                  Huấn luyện cá nhân hóa riêng với Coach
                </p>

                {/* CTA Button */}
                <button
                  onClick={() => handleZaloContact('0976950338')}
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gold-gradient text-white font-bold rounded-lg hover:shadow-lg hover:shadow-gold-500/50 transition transform hover:scale-105"
                >
                  <i className="pi pi-phone"></i>
                  <span>Liên hệ tư vấn – <strong>Coach Khang</strong></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

